import { initializeActivity } from "../actions/playerActions";
import { normalizeActivity } from "../utils/utils";
import ambifi from "../ambifi";

export function setActivities(tree, activities) {
	// Need to loop through and normalize each one
	if (activities.length > 1) {
		for (var i = 1; i < activities.length; i++) {
			var activity = activities[i];

			initializeActivity(tree, ambifi.persistenceManager.restoreActivityResponsesAndState(normalizeActivity(activity)), null); //eslint-disable-line
			activities[i] = tree.get(["activity"]);
		}

		initializeActivity(tree, ambifi.persistenceManager.restoreActivityResponsesAndState(normalizeActivity(activities[0])), null); //eslint-disable-line
		activities[0] = tree.get(["activity"]);

		tree.set(["activities"], activities);
	} else {
		initializeActivity(tree, ambifi.persistenceManager.restoreActivityResponsesAndState(normalizeActivity(activities[0])), null);

		tree.set(["activities"], activities);
	}
}